<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombre"
              label-for="Nombre"
            >
              <b-form-input
                id="Nombre"
                v-model="formData.nombre"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Escribir nombre del bloque"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-form-group
            label="Icono"
            label-for="Icono"
          >
            <b-form-input
              id="Icono"
              v-model="formData.icono"
              trim
              placeholder="Escribir icono del bloque"
            />
          </b-form-group>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, { emit }) {
    const isBusy = ref(false)
    const titleForm = ref('')
    const blankData = {
      icono: '',
      nombre: '',
      id_encuesta: 0,
    }

    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }
    const onSubmit = () => {
      isBusy.value = true
      let service = 'gsencuesta/BLOQUE_CREATE'
      if (props.formType === 'edit') {
        service = 'gsencuesta/BLOQUE_UPDATE'
      }
      store.dispatch(service, formData.value)
        .then(response => {
          isBusy.value = false
          emit('refetch-data', response)
          emit('update:is-add-new-user-sidebar-active', false)
        })
        .catch(error => {
          isBusy.value = false
          emit('error-data', error)
          // emit('update:is-add-new-user-sidebar-active', false)
        })
    }
    const toggleSidebar = val => {
      emit('update:is-add-new-user-sidebar-active', val)
      if (props.formType === 'new') {
        titleForm.value = 'Nuevo Bloque'
      }
      if (props.formType === 'edit') {
        formData.value = {
          idBloque: props.dataEdit.idBloque,
          nombre: props.dataEdit.nombre,
          icono: props.dataEdit.icono,
          id_encuesta: props.dataEdit.id_encuesta,
        }
        titleForm.value = 'Editar Bloque'
      }
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      formData,
      onSubmit,
      titleForm,
      refFormObserver,
      getValidationState,
      resetForm,
      toggleSidebar,
      isBusy,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
